import { SupportButton } from "@/components/SupportModal";

export const Footer = () => (
  <footer className="border-t border-white/10" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 py-10 flex flex-col sm:flex-row gap-6 sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <span className="w-2.5 h-2.5 bg-[#FF3B00]" />
        <span className="font-display font-semibold uppercase tracking-widest text-sm">CNCroutersoft</span>
      </div>
      <p className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/35">
        Windows 10/11 · Free for personal use · © {new Date().getFullYear()}
      </p>
      <div className="flex items-center gap-4">
        <SupportButton testId="support-email-link" />
        <a
          href="mailto:cncroutersoft@gmail.com"
          className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/35 hover:text-[#FF3B00] transition-colors"
          data-testid="support-direct-email"
        >
          cncroutersoft@gmail.com
        </a>
      </div>
      <p className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/35">
        This site never touches your CNC hardware
      </p>
    </div>
  </footer>
);
